import { Button } from "@/components/ui/button";
import { Input } from "@/components/Input";
import { User } from "@/redux/services/user/user.type";
import { useEditProfil } from "@/hooks/parametres/useEditProfil";
import { Save, UserCircle } from "lucide-react";
import IdentifierVerificationDialog from "./IdentifierVerificationDialog";

const InfoUser = ({ currentUser }: { currentUser: User }) => {
  const {
    register,
    onSubmit,
    errors,
    isLoading,
    pendingIdentifier,
    isVerifying,
    codeError,
    isConfirming,
    isRequesting,
    openVerification,
    closeVerification,
    confirmCode,
    resendCode,
  } = useEditProfil();
  return (
    <form onSubmit={onSubmit} className="[&_input]:py-2 [&_input]:text-sm">
      <div className="flex items-center gap-2 mb-5">
        <div className="p-1.5 rounded-lg bg-accent-light">
          <UserCircle className="h-4 w-4 text-accent" />
        </div>
        <h4 className="font-semibold text-card-foreground">
          Informations personnelles
        </h4>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
        <div>
          <Input
            label="Nom complet"
            type="text"
            id="name"
            placeholder="Nom complet"
            required
            {...register("fullName")}
            error={errors?.fullName}
            defaultValue={currentUser?.fullName}
          />
        </div>
        <div>
          <Input
            label="Email"
            type="email"
            id="email"
            placeholder="Aucun email"
            {...register("email")}
            error={errors?.email}
            defaultValue={currentUser?.email ?? ""}
          />
        </div>
        <div>
          <Input
            label="Téléphone"
            type="text"
            id="phone"
            required
            {...register("phone")}
            error={errors?.phone}
            defaultValue={currentUser?.phone ?? ""}
          />
        </div>
        <p className="md:col-span-2 text-xs text-muted-foreground">
          Le téléphone et l'email servent à vous connecter. Un nouveau numéro ou
          email ne sera pris en compte qu'après saisie du code que nous y
          enverrons.
        </p>
        {pendingIdentifier && !isVerifying && (
          <p className="md:col-span-2 text-xs text-card-foreground">
            Un changement vers {pendingIdentifier} attend sa confirmation.{" "}
            <button
              type="button"
              className="font-medium text-primary underline"
              onClick={openVerification}
            >
              Saisir le code
            </button>
          </p>
        )}
      </div>

      <div className="flex justify-end">
        <Button isLoading={isLoading} className="flex items-center gap-2">
          <Save className="h-4 w-4" />
          Enregistrer
        </Button>
      </div>

      <IdentifierVerificationDialog
        open={isVerifying}
        identifier={pendingIdentifier}
        error={codeError}
        isConfirming={isConfirming}
        isResending={isRequesting}
        onConfirm={confirmCode}
        onResend={resendCode}
        onClose={closeVerification}
      />
    </form>
  );
};

export default InfoUser;
